import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './components/NavBar';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Update document title based on route for SEO
  useEffect(() => {
    const titles: Record<string, string> = {
      '/work-experience': 'Work Experience | Shivom Sharma — AI Lead',
      '/skills': 'Skills | Shivom Sharma — AI Lead',
      '/projects': 'Projects | Shivom Sharma — AI Lead',
      '/open-source': 'Open Source | Shivom Sharma — AI Lead',
      '/resume': 'Resume | Shivom Sharma — AI Lead',
      '/contact': 'Contact | Shivom Sharma — AI Lead',
      '/reading': 'Reading List | Shivom Sharma — AI Lead',
      '/blogs': 'Blogs | Shivom Sharma — AI Lead',
      '/certifications': 'Certifications | Shivom Sharma — AI Lead',
      '/interests': 'Interests | Shivom Sharma — AI Lead',
      '/browse': 'Browse Profiles | Shivom Sharma — AI Lead',
    };

    const baseTitle = 'Shivom Sharma — AI Lead | Agent Infrastructure & Crypto Research';
    document.title = titles[location.pathname] || baseTitle;
  }, [location.pathname]);

  return (
    <>
      {/* Skip to main content link for accessibility */}
      <a href="#main-content" className="skip-link" style={{
        position: 'absolute',
        left: '-9999px',
        top: 'auto',
        width: '1px',
        height: '1px',
        overflow: 'hidden'
      }}>
        Skip to main content
      </a>

      <header role="banner">
        <Navbar />
      </header>

      <main id="main-content" role="main" className="content">
        {children}
      </main>

      <footer role="contentinfo" style={{ display: 'none' }}>
        <p>&copy; {new Date().getFullYear()} Shivom Sharma. All rights reserved.</p>
      </footer>
    </>
  );
};

export default Layout;
